export default __webpack_public_path__ + "static/media/boa-his.183a3293.png";